module.exports = __webpack_public_path__ + "static/media/CoverFanpad.d78e60a0.webp";